<script lang="ts" setup>
	defineProps<{
		planDetails: unknown
		pending?: boolean
	}>()
</script>

<template>
	<div class="flex flex-col justify-center">
		<div class="mx-auto inline-flex h-[45px] items-center justify-evenly gap-4 bg-gray-50 px-5 py-4">
			<h4 class="text-sm font-medium text-blue-950"> Plan Status </h4>
			<my-cover-plan-status class="!p-[4px_18px]" :plan-details="planDetails" :pending="pending" fill />
		</div>
	</div>
</template>
